import React, { useState, useRef, useEffect } from 'react';
import './drop_down.css'
import { FaChevronRight, FaChevronDown } from "react-icons/fa";

function Dropdown({ options, onSelect }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const dropdownRef = useRef(null);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedValue(option);
    onSelect(option);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="dropdown" ref={dropdownRef}>

      <button className="dropdown-button" onClick={toggleDropdown}>
        <div id="labelSpace">
        {selectedValue || 'Search By'}
        </div>
        
        <span class="dropdownIcon">
          {isOpen ? <FaChevronDown/> : <FaChevronRight/>}
        </span>

      </button>

      {isOpen && (
        <ul className="dropdown-menu">
          {options.map((option) => (
            <li
            key={option}
            onClick={(e) => {
              e.preventDefault(); // important
              handleOptionClick(option);
            }}
          >
            {option}
          </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Dropdown;